import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'DOCUMENT',
    icon: 'menu-document',
    label: '单证管理',
    path: '/document',
  },
] satisfies Menu[];
